module.exports = __webpack_public_path__ + "img/ylkt4-3.d4a69a6c.jpg";